import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Grid, IconButton, Paper, Tooltip, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import InputField from 'components/formFields/InputField';
import InputNumeric from 'components/formFields/InputNumeric';
import TextAreaField from 'components/formFields/TextAreaField';
import AutocompleteField from 'components/formFields/autocompleteField';
import { storeFamilyBeneficiarios } from 'store/size_family';
import { storeItemsStore } from 'store/size_items';

export const DinamicDotacion = ({ children }: any) => {
  const dispatch = useDispatch();
  const formikProps: any = useFormikContext();

  // REDUX
  const { sizeItemsDotacion }: any = useSelector((state: any) => state.sizeItems);

  const dotacionList = [
    { label: 'bata mantenimiento', value: 'bata_mantenimiento' },
    { label: 'blazer', value: 'blazer' },
    { label: 'blusa', value: 'blusa' },
    { label: 'botas', value: 'botas' },
    { label: 'bufanda', value: 'bufanda' },
    { label: 'camisa', value: 'camisa' },
    { label: 'chaqueta impermeable', value: 'chaqueta_impermeable' },
    { label: 'corbata', value: 'corbata' },
    { label: 'delantal', value: 'delantal' },
    { label: 'falda short', value: 'falda_short' },
    { label: 'grillo', value: 'grillo' },
    { label: 'jean', value: 'jean' },
    { label: 'pantalon', value: 'pantalon' },
    { label: 'zapatos', value: 'zapatos' },
  ];

  const removeItem = async (index: number) => {
    if (
      Array.isArray(sizeItemsDotacion) &&
      sizeItemsDotacion.length > 0 &&
      index >= 0 &&
      index < sizeItemsDotacion.length
    ) {
      const currentItem = [...formikProps.values.items]; // 🔹 Toma el estado actual
      currentItem.splice(index, 1); // 🔹 Remueve del form actual
      formikProps.setFieldValue('items', currentItem); // 🔹 Actualiza Formik
      await dispatch(storeItemsStore(currentItem)); // 🔹 Opcional: actualiza Redux si necesitas

      // const updatedItems = [...sizeItemsDotacion];
      // updatedItems.splice(index, 1);
      // await dispatch(storeItemsStore(updatedItems));
      // formikProps.setFieldValue('items', updatedItems);
    }
  };

  const handleItemChange = (index: number, field: string, value: any) => {
    const currentItems = [...(formikProps.values.items || [])];

    if (!currentItems[index]) {
      currentItems[index] = {};
    }

    currentItems[index][field] = value;
    formikProps.setFieldValue('items', currentItems);
    dispatch(storeItemsStore(currentItems)); // opcional si usas Redux
  };

  return (
    <>
      {children.map((_: any, index: number) => (
        <Paper
          elevation={3}
          sx={{
            p: 5,
            mb: 4,
            borderRadius: 3,
            backgroundColor: '#fdfdfd',
            boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
          }}
          key={index}
        >
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Dotación {index + 1}
            </Typography>
            <Tooltip title="Eliminar item" arrow>
              <IconButton color="error" onClick={() => removeItem(index)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Grid>

          <Grid container spacing={2} style={{ marginTop: 10 }}>
            <Grid size={{ xs: 2 }}>
              <AutocompleteField
                options={dotacionList}
                name={`items[${index}].nombre`}
                label={'Item'}
                element={`items[${index}].nombre`}
                required
                onChange={(e: any, value: any) =>
                  handleItemChange(index, 'nombre', value?.value || '')
                }
              />
            </Grid>
            <Grid size={{ xs: 2 }}>
              <InputField
                name={`items[${index}].talla`}
                label={'Talla'}
                fullWidth
                required
                onBlur={(e: any) => handleItemChange(index, 'talla', e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 2 }}>
              <InputNumeric
                name={`items[${index}].cantidad`}
                label={'Cantidad'}
                fullWidth
                required
                onBlur={(e: any) => handleItemChange(index, 'cantidad', e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 2 }}>
              <InputField
                name={`items[${index}].color`}
                label={'Color'}
                fullWidth
                required
                onBlur={(e: any) => handleItemChange(index, 'color', e.target.value)}
              />
            </Grid>
            <Grid size={{ xs: 4 }}>
              <TextAreaField
                name={`items[${index}].descripcion`}
                label={'Descripción'}
                fullWidth
                required
                onBlur={(e: any) => handleItemChange(index, 'descripcion', e.target.value)}
              />
            </Grid>
          </Grid>
        </Paper>
      ))}
    </>
  );
};
